import React, { useState, useEffect } from "react";
import GradientButton from "../../components/button/Button";
import PlainButton from "../../components/button/PlainButton";
import axiosInstance from "../../axiosInstance";

interface ProductSegment {
  id: string;
  name: string;
}

interface FilterModalProps {
  isOpen: boolean;
  onClose: () => void;
  onFilter: (filters: {
    name: string;
    category: string;
    lis: string;
    priceMin: string;
    priceMax: string;
  }) => void;
}

const FilterStockModal: React.FC<FilterModalProps> = ({
  isOpen,
  onClose,
  onFilter,
}) => {
  const [filters, setFilters] = useState({
    name: "",
    category: "",
    lis: "",
    priceMin: "",
    priceMax: "",
  });

  const [segments, setSegments] = useState<ProductSegment[]>([]);
  const [loadingCategories, setLoadingCategories] = useState(false);

  useEffect(() => {
    const getCategories = async () => {
      setLoadingCategories(true);
      try {
        const res = await axiosInstance.get("/segments");
        if (res?.data) {
          setSegments(res.data?.data || []);
        }
        setLoadingCategories(false);
      } catch (error) {
        setLoadingCategories(false);
        console.error("Error fetching categories:", error);
      }
    };
    getCategories();
  }, []);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const handleFilter = () => {
    onFilter(filters);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="orders-modal">
      <div className="orders-modal__overlay" onClick={onClose}></div>
      <div className="orders-modal__content">
        <div className="orders__modal__header">
          <h2 className="orders-modal__title">Filter</h2>
          <button className="orders-modal__close" onClick={onClose}>
            &times;
          </button>
        </div>
        <form className="orders-modal__form">
          <div className="orders-modal__form-group">
            <label htmlFor="name">Product name</label>
            <input
              type="text"
              id="name"
              name="name"
              placeholder="Enter product name"
              value={filters.name}
              onChange={handleChange}
            />
          </div>
          <div className="orders-modal__form-group">
            <label htmlFor="category">Product category</label>
            <select
              id="category"
              name="category"
              value={filters.category}
              onChange={handleChange}
            >
              <option value="">Select Category</option>
              {loadingCategories ? (
                <option disabled>Loading categories...</option>
              ) : (
                segments.map((category) => (
                  <option key={category.name} value={category.name}>
                    {category.name}
                  </option>
                ))
              )}
            </select>
          </div>
          <div className="orders-modal__form-group">
            <label htmlFor="lis">Left in stock</label>
            <input
              type="number"
              id="lis"
              name="lis"
              value={filters.lis}
              onChange={handleChange}
              placeholder="Enter left in stock"
            />
          </div>

          <div className="orders-modal__form-group">
            <label>Price Range</label>
            <div style={{ display: "flex", gap: 8 }}>
              <input
                type="number"
                id="priceMin"
                name="priceMin"
                placeholder="Min"
                value={filters.priceMin}
                onChange={handleChange}
                style={{ flex: 0.5, width: "50%" }}
              />
              <input
                type="number"
                id="priceMax"
                name="priceMax"
                placeholder="Max"
                value={filters.priceMax}
                onChange={handleChange}
                style={{ flex: 0.5, width: "50%" }}
              />
            </div>
          </div>
        </form>
        <div className="orders-modal__actions">
          <div className="orders-modal__clear">
            <PlainButton
              onClick={() =>
                setFilters({
                  name: "",
                  category: "",
                  lis: "",
                  priceMin: "",
                  priceMax: "",
                })
              }
              text="Clear Filter"
            />
          </div>
          <div className="orders-modal__apply">
            <GradientButton onClick={handleFilter} text="Filter" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterStockModal;
